import React from 'react'
import { useNavigate } from 'react-router-dom'

export const withNavigate = <P extends object>(Component: React.ComponentType<P>) => (
  props: any
) => {
  const navigate = useNavigate()
  return <Component {...(props as P)} navigate={navigate} />
}
